import { observer } from 'mobx-react-lite';
import * as React from 'react';
import CharmPicker, { CharmPickerHandle } from 'owa-charmpicker/lib/components/CharmPicker';
import { getComposeStore } from 'owa-calendar-compose-store-manager';
import type { CharmPickerPropsBase } from 'owa-charmpicker/lib/components/CharmPickerPropsBase';
import { getEffectiveCharm, getNoCharmInfoObject } from 'owa-calendar-charms-store';

export interface SmartCharmPickerHandle {
    focus(): void;
}

export default observer(
    function SmartCharmPicker(props: CharmPickerPropsBase, ref: React.Ref<SmartCharmPickerHandle>) {
        const charmPicker = React.useRef<CharmPickerHandle>();

        React.useImperativeHandle(
            ref,
            () => ({
                focus() {
                    charmPicker.current.focus();
                },
            }),
            []
        );
        let event = getComposeStore().event;
        // Retrieve calendar charm from calendars cache if event has no charm
        let charm = props.disabled
            ? getNoCharmInfoObject()
            : getEffectiveCharm(event.ParentFolderId, event.CharmId);
        return (
            <CharmPicker
                selectedCharm={charm}
                {...props}
                ref={ref => {
                    if (ref) {
                        charmPicker.current = ref;
                    }
                }}
            />
        );
    },
    { forwardRef: true }
);
